/**
 * @overview Font family mixins
 */

import { css } from 'styled-components';

const garamond = `adobe-garamond-pro`;
const brandonGrotesque = `brandon-grotesque`;
const roboto = `"Roboto"`;
const azoSans = `"Azo Sans"`;
const elaine = `"Elaine D02"`;
const addwithfallback = (fontFamily) => `${fontFamily}, Helvetica, Arial, sans-serif`;

export const robotoLight = css`
  font-style: normal;
  font-weight: 300;
  font-family: ${addwithfallback(roboto)};
`;

export const elaineRegular = css`
  font-style: normal;
  font-weight: 400;
  font-family: ${addwithfallback(elaine)};
`;

export const azoSansRegular = css`
  font-style: normal;
  font-weight: 400;
  font-family: ${addwithfallback(azoSans)};
`;

export const azoSansBlack = css`
  font-style: normal;
  font-family: ${addwithfallback(azoSans)};
`;

export const azoSansBold = css`
  font-style: normal;
  font-weight: 700;
  font-family: ${addwithfallback(azoSans)};
`;

export const azoSansLight = css`
  font-style: normal;
  font-weight: 300;
  font-family: ${addwithfallback(azoSans)};
`;

export const azoSansMedium = css`
  font-style: normal;
  font-weight: 500;
  font-family: ${addwithfallback(azoSans)};
`;

export const brandonGrotesqueRegular = css`
  font-style: normal;
  font-weight: 400;
  font-family: ${addwithfallback(brandonGrotesque)};
`;

export const brandonGrotesqueBold = css`
  font-style: normal;
  font-weight: 700;
  font-family: ${addwithfallback(brandonGrotesque)};
`;

export const brandonGrotesqueLight = css`
  font-style: normal;
  font-weight: 300;
  font-family: ${addwithfallback(brandonGrotesque)};
`;

export const brandonGrotesqueMedium = css`
  font-style: normal;
  font-weight: 500;
  font-family: ${addwithfallback(brandonGrotesque)};
`;

export const garamondRegular = css`
  font-style: normal;
  font-weight: 400;
  font-family: ${addwithfallback(garamond)};
`;

export const garamondSemibold = css`
  font-style: normal;
  font-weight: 600;
  font-family: ${addwithfallback(garamond)};
`;

export const garamondRegularItalic = css`
  font-style: italic;
  font-weight: 400;
  font-family: ${addwithfallback(garamond)};
`;

export const garamondSemiboldItalic = css`
  font-style: italic;
  font-weight: 600;
  font-family: ${addwithfallback(garamond)};
`;